import React from 'react';
import { NavDropdown } from "react-bootstrap";

import SaleReportLink from "../sale_report/SaleReportLink";

import ApiKeyContext from "../../../../contexts/ApiKeyContext";
import { useAuth } from "../../../../auth/useAuth";
import { ProductUtil } from "../../../../util/Product.util";

export default function ProductDetailMenu({ item, catalog, close }) {
	const { organizationMember } = useAuth();

	// TODO: Pass organization handle
	// TODO: Pass profile handle
	const options = {
		fieldset: catalog.detail_fieldset?.handle,
		catalog: catalog.id
	}
	const openPdf = () => window.open(pdf_url.toString());

	const organization_member_data = JSON.parse(localStorage.getItem('organization_member:data')) || organizationMember;
	const pdf_url = ProductUtil.Make_Pdf_Url({
		product: item,
		profile_token: organization_member_data?.profile?.public_token,
		organization: organization_member_data?.organization?.handle,
		catalog: catalog?.slug,
	});
	pdf_url?.searchParams.set("options", JSON.stringify(options));

	return (
		<NavDropdown className="menu" title="">
			{
				catalog.options.sale_report?.report
				&& item
				&& (
					<NavDropdown.Item>
						<SaleReportLink form={catalog.options.sale_report.form} item={item} />
					</NavDropdown.Item>
				)
			}
			{pdf_url && <NavDropdown.Item onClick={openPdf}><span>Open PDF</span></NavDropdown.Item>}
			<NavDropdown.Item onClick={close}><span>Close</span></NavDropdown.Item>
		</NavDropdown>
	);
}